<template>
  <div>
    <el-button v-if="show"
        :size="size"
        @click="onAttributeButtonClick">
      属性情報
    </el-button>

    <!-- 属性情報モーダル -->
    <BaseDialog
        title="属性情報"
        :visible.sync="showAttributeDialog"
        :show-only-close-button="!editable"
        :append-to-body="appendToBody"
        @closed="attributeDialogClose"
        @cancel="attributeDialogClose"
        @ok="attributeDialogOk">
      <template slot="contents">
        <AttributeTable
            :keys="keys"
            :values="copyAttributeValues"
            :editable="editable"
            height="350" />
      </template>
    </BaseDialog>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'

import AttributeTable from '@/components/molecules/AttributeTable'
import BaseDialog from '@/components/molecules/BaseDialog'

export default {
  name: 'AttributeButton',
  components: {
    AttributeTable,
    BaseDialog
  },
  props: {
    siteCode: {
      type: String,
      default: null
    },
    pageName: {
      type: String,
      default: ''
    },
    areaName: {
      type: String,
      default: ''
    },
    attributeValues: {
      type: Array,
      default: () => ([])
    },
    editable: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'mini',
      validator (value) {
        return ['medium', 'small', 'mini', ''].indexOf(value) !== -1
      }
    },
    appendToBody: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showAttributeDialog: false,
      copyAttributeValues: []
    }
  },
  computed: {
    ...mapGetters({
      attributeKeys: 'attributeKeys'
    }),
    keys () {
      return this.attributeKeys(this.siteCode, this.pageName, this.areaName)
    },
    show () {
      return this.keys.length > 0
    }
  },
  methods: {
    onAttributeButtonClick () {
      this.copyAttributeValues = _.chain(this.attributeValues)
        .cloneDeep()
        .thru(val => {
          /*
           * 以下の順番に並び替える
           * 1. サービスサイト設定にキーが存在しない属性情報
           * 2. サービスサイト設定にキーが存在する属性情報
           *    1. 登録済みの属性情報
           *       1. サービスサイト設定の表示順
           *    2. 追加された属性情報
           *       1. 追加順
           */
          return _.concat([],
            _.filter(val, val => !val.new && _.find(this.keys, key => key.id === val.attrId) == null),
            _.chain(val)
              .filter(val => !val.new && _.find(this.keys, key => key.id === val.attrId) != null)
              .map(val => {
                const found = _.find(this.keys, key => key.id === val.attrId)
                val.order = found.order
                return val
              })
              .sortBy(['order'])
              .value(),
            _.filter(val, val => val.new)
          )
        })
        .value()
      this.showAttributeDialog = true
    },
    attributeDialogOk () {
      _.chain(this.copyAttributeValues)
        .filter(val => val.attrId != null)
        .forEach(val => {
          const id = val.attrId
          if (val.new) {
            const index = _.findIndex(this.attributeValues, val => val.attrId === id)
            if (index === -1) {
              this.attributeValues.push(val)
            } else {
              this.attributeValues.splice(index, 1)
              this.attributeValues.push(val)
            }
          } else {
            const found = _.find(this.attributeValues, val => val.attrId === id)
            found.attrValue = val.attrValue
          }
        })
        .value()
      this.attributeDialogClose()
    },
    attributeDialogClose () {
      this.copyAttributeValues = []
      this.showAttributeDialog = false
    }
  }
}
</script>
